import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'

// Views
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import Tests from '../views/Tests.vue'
import TestSession from '../views/TestSession.vue'
import Results from '../views/Results.vue'
import SessionResults from '../views/SessionResults.vue'
import Admin from '../views/Admin.vue'
import Profile from '../views/Profile.vue'
import AnonymousTest from '../views/AnonymousTest.vue'

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { requiresGuest: true }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: { requiresAuth: true }
  },
  {
    path: '/tests',
    name: 'tests',
    component: Tests,
    meta: { requiresAuth: true }
  },
  {
    path: '/test/:id',
    name: 'test-session',
    component: TestSession,
    meta: { requiresAuth: true }
  },
  {
    path: '/results',
    name: 'results',
    component: Results,
    meta: { requiresAuth: true }
  },
  {
    path: '/session/:sessionId/results',
    name: 'session-results',
    component: SessionResults,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin',
    name: 'admin',
    component: Admin,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile,
    meta: { requiresAuth: true }
  },
  {
    path: '/:uuid',
    name: 'anonymous-test',
    component: AnonymousTest,
    meta: { requiresAuth: false },
    props: true
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Navigation guards
router.beforeEach(async (to, from, next) => {
  const isAuthenticated = store.state.isAuthenticated
  
  // If route requires authentication and user is not authenticated
  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/login')
    return
  }
  
  // If route requires guest (login/register) and user is authenticated
  if (to.meta.requiresGuest && isAuthenticated) {
    next('/dashboard')
    return
  }
  
  // If route requires admin and user is not admin
  if (to.meta.requiresAdmin && store.state.currentUser?.role !== 'admin') {
    next('/dashboard')
    return
  }
  
  // If user is authenticated but currentUser is not loaded, fetch it
  if (isAuthenticated && !store.state.currentUser) {
    await store.dispatch('fetchCurrentUser')
  }
  
  next()
})

export default router 